"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AvatarFallback = require("./AvatarFallback");
Object.keys(_AvatarFallback).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AvatarFallback[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AvatarFallback[key];
    }
  });
});